export class FileUploadPlacardConfirmationRequest {
    public placardLocation: string = '';
    public metalBoxInd: boolean;
    public pickupLocation: string = '';
    public additionalLocationDetails: string = '';
    public lockCombination: string = '';
    public placardImage: ItemFile;
    public placardDisplayed: boolean;
    public pickupStartDate: string='';
}

 interface ItemFile {
     name: string;
     contents: string;
     extension: string;
}
